import { useState } from "react";
import { photoUrl } from "@/lib/api";

export default function BeforeAfter({ item, className = "" }) {
  const [pos, setPos] = useState(50);
  return (
    <div
      className={`relative select-none overflow-hidden rounded-2xl border border-white/10 bg-[#1a2234] ${className}`}
      data-testid={`before-after-${item.id}`}
    >
      <img src={photoUrl(item.after_photo_id)} alt="After" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <img
        src={photoUrl(item.before_photo_id)}
        alt="Before"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable={false}
      />
      <div className="absolute top-0 bottom-0 w-0.5 bg-[#ff6b00] shadow-[0_0_12px_rgba(255,107,0,0.8)]" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-9 w-9 rounded-full bg-[#ff6b00] border-2 border-[#0b0f17] flex items-center justify-center font-mono text-[10px] font-bold text-[#0b0f17]">
          ⇔
        </div>
      </div>
      <span className="absolute top-3 left-3 cj-pill bg-[#0b0f17]/80 border border-white/10 text-slate-200">Before</span>
      <span className="absolute top-3 right-3 cj-pill bg-[#ff6b00] border border-[#ff6b00] text-[#0b0f17]">After</span>
      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Compare before and after"
        data-testid={`before-after-slider-${item.id}`}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
      />
    </div>
  );
}
